import { render, staticRenderFns } from "./DocumentOptions.vue?vue&type=template&id=0e49ae07"
import script from "./DocumentOptions.vue?vue&type=script&lang=js"
export * from "./DocumentOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports